/**
 * Cross-view bridge. Allows components in the Pitch view to switch to the
 * Dossier view (or vice-versa) while passing a small hint payload.
 *
 * The shell (App.js) subscribes to `subscribe` and reacts by changing the
 * active view + storing the hint. Consumers on the target view read the hint
 * once and clear it.
 */
const listeners = new Set();
let currentRequest = null;

export function requestView(view, hint = null) {
  currentRequest = { view, hint, ts: Date.now() };
  listeners.forEach((fn) => fn(currentRequest));
}

export function subscribe(fn) {
  listeners.add(fn);
  if (currentRequest) fn(currentRequest);
  return () => listeners.delete(fn);
}

export function readCurrent() {
  return currentRequest;
}

export function clearHint() {
  if (currentRequest) currentRequest = { ...currentRequest, hint: null };
}
